// extracted by mini-css-extract-plugin
module.exports = {"productlist":"ProductList_productlist__pihyH","title":"ProductList_title__1H5Vf"};